import { gql } from '@apollo/client'

export const UPDATE_MY_USER_PREFERENCE = gql`
  mutation updateMyUserPreference($userId: ID!, $userPreference: UserPreferenceUpdateInput!) {
    user: updateMyUserPreference(id: $userId, userPreference: $userPreference) {
      id
      userPreferences {
        notifyFallbackNoReceipentJob
        language
        hideTestOrganizations
        showActiveTemplatesOnly
      }
    }
  }
`
